import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useMemo } from 'react';
import { useQuery } from '@apollo/client';
import mergeOperations from '@magento/peregrine/lib/util/shallowMerge';
import { useAppContext } from '@magento/peregrine/lib/context/app';
import DEFAULT_OPERATIONS from '@magento/peregrine/lib/talons/Cms/cmsPage.gql';
/**
 * Retrieves data necessary to render a CMS Page
 *
 * @param {object} props
 * @param {object} props.id - CMS Page ID
 * @param {object} props.queries - Collection of GraphQL queries
 * @param {object} props.queries.getCmsPage - Query for getting a CMS Page
 * @returns {{shouldShowLoadingIndicator: *, hasContent: *, cmsPage: *, error: *}}
 */

export var useCmsPage = function useCmsPage(props) {
  var _data$storeConfig;

  var identifier = props.identifier;
  var operations = mergeOperations(DEFAULT_OPERATIONS, props.operations);
  var getCMSPageQuery = operations.getCMSPageQuery;

  var _useQuery = useQuery(getCMSPageQuery, {
    variables: {
      identifier: identifier
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-only'
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  var _useAppContext = useAppContext(),
      _useAppContext2 = _slicedToArray(_useAppContext, 2),
      setPageLoading = _useAppContext2[1].actions.setPageLoading; // To prevent loading indicator from getting stuck, unset on unmount.


  useEffect(function () {
    return function () {
      setPageLoading(false);
    };
  }, [setPageLoading]); // Ensure we mark the page as loading while we check the network for updates

  useEffect(function () {
    setPageLoading(loading);
  }, [loading, setPageLoading]);
  var shouldShowLoadingIndicator = loading && !data;
  var cmsPage = data ? data.cmsPage : null;
  var rootCategoryId = data ? (_data$storeConfig = data.storeConfig) === null || _data$storeConfig === void 0 ? void 0 : _data$storeConfig.root_category_id : null; // Only render <RichContent /> if the page isn't empty and doesn't contain
  // the default CMS Page text. We do this so there is at least a useable home
  // page by default, the category list component.

  var hasContent = useMemo(function () {
    return cmsPage && cmsPage.content && cmsPage.content.length > 0 && !cmsPage.content.includes('CMS homepage content goes here.');
  }, [cmsPage]);
  return {
    cmsPage: cmsPage,
    error: error,
    hasContent: hasContent,
    rootCategoryId: rootCategoryId,
    shouldShowLoadingIndicator: shouldShowLoadingIndicator
  };
};